import { routerReducer } from "@angular-redux/router";
import { fromJS } from "immutable";
import { combineReducers } from "redux";
import { contactsReducer } from "../../+authenticated/+customer-master/customer-detail/contacts-v2/reducers/contact-reducer";
import { customersReducer } from "../../+authenticated/+customer-master/customer-detail/reducers/customer-reducer";
import { clientTechProfilesReducer } from "../../+authenticated/+customer-master/customer-detail/tech-profiles/tech-profiles-list-reducer";
import { globalMessageReducer } from "../../+authenticated/global-message/reducers/global-message-reducer";
import { logoutWarningReducer } from "../auth/logout-warning/logout-warning-reducer";
import { GenericActions } from "./generic-actions";

// casted to any to get around TS error that will be fixed in Redux 4
// see: https://github.com/reactjs/redux/issues/2709
export let allReducers: any = {
    router: routerReducer,
    globalMessage: globalMessageReducer,
    logoutWarning: logoutWarningReducer,
    customers: customersReducer,
    contacts: contactsReducer,
    techProfiles: clientTechProfilesReducer,
};

export function mergeReducers(ngRedux, newReducers?): void {
    if (!!newReducers) {
        Object.keys(newReducers).forEach((key) => {
            if (!!allReducers[key]) {
                return;
            } else if (!!newReducers) {
                allReducers[key] = newReducers[key];
            }
        });
    }
    replaceRootReducer(ngRedux);
}

export function componentsReducer(rootProp, state, action) {
    switch (action.type) {
        case `${rootProp}::${GenericActions.COMPONENT_ADDED}`:
            const existingData = state.get(action.stateProp);
            if (existingData && action.useExisting) {
                state = state.mergeIn([action.stateProp], action.payload);
            } else {
                state = state.set(action.stateProp, fromJS(action.payload));
            }
            return state;
        case `${rootProp}::${GenericActions.COMPONENT_REMOVED}`:
            return state.deleteIn([action.stateProp]);
        default:
            return state;
    }
}

function replaceRootReducer(ngRedux): void {
    ngRedux["_store"].replaceReducer(combineReducers(allReducers));
}
